var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallRate5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15z",
    fill: "#26BAAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.448 11.508c0 1.294-.735 2.344-1.64 2.344-.907 0-1.641-1.05-1.641-2.344 0-1.295.734-2.344 1.64-2.344.906 0 1.641 1.05 1.641 2.344zM20.886 11.508c0 1.294-.735 2.344-1.641 2.344s-1.64-1.05-1.64-2.344c0-1.295.734-2.344 1.64-2.344.906 0 1.64 1.05 1.64 2.344z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.563 18.516c0 .708.218 1.409.642 2.063.424.654 1.045 1.248 1.829 1.748.783.5 1.713.898 2.737 1.169 1.024.27 2.121.41 3.229.41s2.205-.14 3.229-.41c1.024-.271 1.954-.668 2.737-1.169.784-.5 1.405-1.095 1.83-1.749.423-.654.642-1.354.642-2.062H6.561z",
    fill: "#fff"
  })));
}
export default SvgSmallRate5;